import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/hooks/useAdminAuth";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const { login } = useAdminAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();
      setError("");
      if (!username.trim()) {
        setError("请输入用户名");
        return;
      }
      if (!password.trim()) {
        setError("请输入密码");
        return;
      }
      setLoading(true);
      const res = await login(username.trim(), password.trim());
      setLoading(false);
      if (res.success) {
        navigate("/admin/overview");
      } else {
        setError(res.error || "登录失败");
      }
    },
    [username, password, login, navigate]
  );

  return (
    <div className="min-h-screen bg-[#f8f5f0] flex flex-col items-center justify-center px-5 py-8">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-10">
          <div className="w-20 h-20 rounded-2xl overflow-hidden mb-5 bg-white shadow-sm flex items-center justify-center p-2">
            <img
              src="/logo.jpg"
              alt="RTB Logo"
              className="w-full h-full object-contain"
            />
          </div>
          <h1 className="text-xl font-bold text-[#1a3a5c] tracking-wide">
            RTB 管理后台
          </h1>
          <p className="text-xs text-gray-400 mt-1.5">
            CRM 系统管理员登录
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-sm p-6 md:p-8">
          <h2 className="text-base font-semibold text-[#1a3a5c] mb-5 text-center">
            管理员登录
          </h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1.5">
                用户名
              </label>
              <div className="relative">
                <i className="ri-user-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="请输入用户名"
                  className="w-full pl-9 pr-3 py-2.5 rounded-xl border border-gray-200 text-sm text-[#1a3a5c] placeholder:text-gray-300 focus:outline-none focus:border-[#c9a96e] focus:ring-1 focus:ring-[#c9a96e]/20 transition-all bg-white"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1.5">
                密码
              </label>
              <div className="relative">
                <i className="ri-lock-password-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="请输入密码"
                  className="w-full pl-9 pr-3 py-2.5 rounded-xl border border-gray-200 text-sm text-[#1a3a5c] placeholder:text-gray-300 focus:outline-none focus:border-[#c9a96e] focus:ring-1 focus:ring-[#c9a96e]/20 transition-all bg-white"
                />
              </div>
            </div>

            {error && (
              <div className="flex items-center gap-1.5 text-red-500 text-xs bg-red-50 rounded-lg px-3 py-2">
                <i className="ri-error-warning-line"></i>
                <span>{error}</span>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 bg-[#1a3a5c] hover:bg-[#142d48] text-white font-semibold py-3 rounded-xl transition-all active:scale-[0.98] disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap text-sm"
            >
              {loading ? (
                <>
                  <i className="ri-loader-4-line animate-spin"></i>
                  登录中...
                </>
              ) : (
                <>
                  <i className="ri-shield-user-line"></i>
                  管理员登录
                </>
              )}
            </button>
          </form>

          <div className="mt-6 pt-4 border-t border-gray-100 text-center">
            <a
              href="/login"
              className="text-[11px] text-[#c9a96e] hover:underline cursor-pointer"
            >
              <i className="ri-arrow-left-line mr-1"></i>
              返回客户登录
            </a>
          </div>
        </div>
      </div>

      <footer className="mt-auto pt-8 pb-4 text-center w-full">
        <p className="text-[11px] text-gray-400">RTB 吉尔吉斯斯坦试管助孕中心</p>
        <p className="text-[10px] text-gray-300 mt-0.5">客户全周期管理 CRM 系统</p>
        <p className="text-[10px] text-gray-300 mt-1">&copy; 2025 RTB Fertility. All Rights Reserved.</p>
      </footer>
    </div>
  );
}